import React, { PureComponent } from "react";

import Loader from "components/Loader/Loader.js";
import { Metric, Error } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

class LeeChurn extends PureComponent {
  render() {
    const { loading, data } = this.props;

    if (data.data.hasData === false) {
      return <Error minHeight={260} />;
    }
    if (loading) {
      return <Loader minHeight={200} col={"col-12 col-md-6"} />;
    }

    return (
      <div className="row mt-2">
        {data.data.churn && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Churn
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.churn} size={"lg"} format={"%"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Digital Only</h6>
              <Metric
                {...data.data.churn_digital_only}
                size={"xs"}
                format={"%"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Full Access</h6>
              <Metric
                {...data.data.churn_full_access}
                size={"xs"}
                format={"%"}
              />
            </div>
          </div>
        )}

        {data.data.first_subscription && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              First Subscription
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.first_subscription} size={"lg"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Digital Only</h6>
              <Metric
                {...data.data.first_subscription_digital_only}
                size={"xs"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Full Access</h6>
              <Metric
                {...data.data.first_subscription_full_access}
                size={"xs"}
              />
            </div>
          </div>
        )}

        {data.data.subsequent_subscription && (
          <div className="col mb-3 mb-sm-0">
            <Heading size={6} className={"mb-1"}>
              Subsequent Subscription
            </Heading>

            <div className="d-flex">
              <Metric {...data.data.subsequent_subscription} size={"lg"} />
            </div>

            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Digital Only</h6>
              <Metric
                {...data.data.subsequent_subscription_digital_only}
                size={"xs"}
              />
            </div>
            <div className="d-flex justify-content-left align-items-center">
              <h6 className="mb-0 mr-2">Full Access</h6>
              <Metric
                {...data.data.subsequent_subscription_full_access}
                size={"xs"}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LeeChurn;
